


























































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue'
import { SearchCondition, StudentSubject } from "../../modules/teacher/StudentSubjectList"
import { downloadMasterExcel } from "../../modules/teacher/MasterExcelDownload"

export interface Data {
  tabNo: number
  condition: SearchCondition
  student_subjects: StudentSubject[]
  fields: any[]
  isShowPagination: boolean
  isAllDeleteChecked: boolean
  totalCount: number
  isDownloading: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 7,
      condition: new SearchCondition(),
      student_subjects: new Array<StudentSubject>(),
      fields: [
        {key: "student_code", label: "生徒CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_name", label: "生徒名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "subject_code", label: "科目CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "subject_name", label: "科目名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", sortable: true, class: 'text-center b-table-th-td'},
        {key: "course_name", label: "コース", sortable: true, class: 'text-center b-table-th-td'},
        {key: "campus_name", label: "キャンパス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "class_name", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        // {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        // {key: "kumi", label: "組", sortable: true, class: 'text-center b-table-th-td'},
        // {key: "student_no", label: "出席番号", sortable: true, class: 'text-center b-table-th-td'},
        // {key: "status", label: "在校状態", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center', thStyle: {width: "80px"}},
      ],
      errors: [],
      isShowPagination: false,
      isAllDeleteChecked: false,
      totalCount: 0,
      isDownloading: false,
    });

    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = async (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: any) => x.is_checked = isChecked);
    };

    /******************************
     * 削除
     ******************************/

    const deleteMst = async (): Promise<void> => {

      if(state.student_subjects.filter(x => x.is_checked).length == 0){
        alert("削除対象が選択されていません。");
        return;
      }

      if(!window.confirm("削除を実行します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      const delete_ids: number[] = state.student_subjects.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/teacher/student_subject_list/delete`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      state.errors = [];
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/student_subject_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.student_subjects = response.data.student_subjects.map((x: any) => new StudentSubject(x));
        state.totalCount = response.data.full_count
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {
      if(state.isDownloading){
        return;
      }

      state.errors = [];
      state.isDownloading = true;
      try {
        await downloadMasterExcel(context, {
          apiPath: "student_subject_list",
          condition: state.condition,
          fileName: "受講科目マスタ.xlsx",
          confirmMessage: "検索条件に一致する受講科目マスタをダウンロードします。よろしいですか？",
          columns: ["student_code", "subject_code", "nendo"],
          deleteColumnCount: 4,
        });
      }
      finally {
        state.isDownloading = false;
      }
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      search,
      clearCondition,
      changePage,
      allSelectChanged,
      deleteMst,
      download,
      searchButtonClick,
    };
  }
});
